// Shop logo, falling back to the shop name when the shop has no logo.
const ShopLogo = ({ shop, showName = false }) => {
    if (!shop?.id) return null;
    return (
        <div className="portal-shop-logo">
            {shop.logo && <img src={shop.logo} alt={shop.name} />}
            {(showName || !shop.logo) && (
                <span className="portal-shop-logo__name">{shop.name}</span>
            )}
        </div>
    );
};

export default ShopLogo;
